import { Lightning } from '@lightningjs/sdk'

import { transparent } from '../../../constants/colors'
import { TvCardTypesEnum } from '../../../types/flo-enums'
import { toCardRef } from '../../../utils/carouselUtils'
import TvEntityCard from '../../TvCards/TvEntityCard'
import TvEventCard from '../../TvCards/TvEventCard'
import TvNavigationCard from '../../TvCards/TvNavigationCard'
import TvOriginalCard from '../../TvCards/TvOriginalCard'
import TvVideoCard from '../../TvCards/TvVideoCard'

export type RowItem = TvEventCard & TvVideoCard & TvEntityCard & TvNavigationCard & TvOriginalCard

export class TvSearchGridRow extends Lightning.Component {
  private _items: RowItem[]
  private _totalCards = 0
  private _rowIndex = 0
  private _currentCardIndex = 0
  private _isCardFadeInEnabled: boolean = true

  static _template() {
    return {
      w: (w) => w,
      h: (h) => h,
      rect: true,
      color: transparent,
      flex: { direction: 'row' },
    }
  }

  set rowIndex(v: number) {
    this._rowIndex = v
  }

  set items(v: RowItem[]) {
    this._items = v
    this._totalCards = v.length

    const cards = this._items.map((card) => {
      if (card?.data?.type === TvCardTypesEnum.TvEntityCard) {
        ;(card as TvEntityCard).isCardFadeInEnabled = this._isCardFadeInEnabled
      }

      return card
    })

    this.patch({
      children: cards,
    })
  }

  get items() {
    return this._items
  }

  set currentCardIndex(v) {
    this._currentCardIndex = v
  }

  set isCardFadeInEnabled(isEnabled: boolean) {
    this._isCardFadeInEnabled = isEnabled
  }

  get currentCardIndex() {
    return this._currentCardIndex ?? 0
  }

  get currentCard() {
    return this.childList.getByRef(toCardRef(this._currentCardIndex)) as RowItem
  }

  get totalCards() {
    return this._totalCards
  }

  _getFocused() {
    return this.currentCard
  }

  _handleLeft() {
    if (this._currentCardIndex > 0) {
      this._currentCardIndex--
    } else {
      return false
    }
  }

  _handleRight() {
    if (this._currentCardIndex < this._totalCards - 1) {
      this._currentCardIndex++
    } else {
      return false
    }
  }
}
